import axios from '../../axios/ctiConfig';
import ctiRequest from '../../axios/ctiRequests';
import { localStorageFunc } from '../../helpers/utility';
import * as actionTypes from './actionTypes';

export const agentConfigStart = () => {
  return {
    type: actionTypes.AGENT_CONFIG_START,
  };
};

export const agentConfigFail = (error) => {
  return {
    type: actionTypes.AGENT_CONFIG_FAIL,
    error: error,
  };
};

export const agentConfigSuccess = (agentConf,campConf,facilityConf,features,newFeatures,timezone,countryCodes,activeLists,searchParameter) => {
  return {
    type: actionTypes.AGENT_CONFIG_SUCCESS,
    agentConf: agentConf,
    campConf: campConf,
    facilityConf: facilityConf,
    features: features,
    newFeatures: newFeatures,
    timezone: timezone,
    countryCodes: countryCodes,
    activeLists: activeLists,
    searchParameter: searchParameter ? searchParameter.trim() : '',
  };
};

export const agentConfig = (agentId) => {
  return (dispatch) => {
    dispatch(agentConfigStart());
    ctiRequest['CTI_AGENT_CONFIG'].agent_id = agentId;
    ctiRequest['CTI_AGENT_CONFIG'].ip = localStorage.getItem('clientIP') ? localStorage.getItem('clientIP') : '127.0.0.1';
    axios
      .post('/', ctiRequest['CTI_AGENT_CONFIG'])
      .then((result) => {
        if (result.data.response.status === 'SUCCESS') {
          dispatch(agentConfigSuccess(result.data.response.agent_conf,result.data.response.camp_conf,result.data.response.facility_conf,result.data.response.features,result.data.response.new_features,result.data.response.timezone,result.data.response.country_codes,result.data.response.active_lists,result.data.response.search_parameter));
                    localStorageFunc.set("callCount",result.data.response.camp_conf.per_call_count )
                    localStorageFunc.set("callerFlag", result.data.response.camp_conf.third_party_caller_id)
        } else {
          dispatch(agentConfigFail(result.data.response.reason));
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch(agentConfigFail(err));
      });
  };
};